import type { DrawinkFontFaceDescriptor } from "../Fonts";

import CascadiaCodeRegular from "./CascadiaCode-Regular.woff2";

export const CascadiaFontFaces: DrawinkFontFaceDescriptor[] = [
  {
    uri: CascadiaCodeRegular,
  },
];
